<div
  class="tile"
  [class.show]="
    minesService.currentGame().status === 'finished' ||
    (isOpened() && minesService.currentGame().status === 'active')
  "
>
  <div class="tile--front">
    <div class="tile--wrapper gray">
      <img
        src="assets/images/core/tf2-logo-hex.png"
        alt="logo-tf2"
        class="logo"
      />
    </div>
  </div>
  <div class="tile--back" [class.opacity]="opacityEffect()">
    @if ((isOpened() || minesService.currentGame().status === 'finished') &&
    !uiService.breakpoints().max_lg) {
    <div class="tile--particles">
      <ngx-particles
        [id]="tile() + '-particles'"
        [options]="isBomb() ? particlesOptionsRed : particlesOptionsYellow"
      ></ngx-particles>
    </div>
    }
    <div
      class="tile--wrapper"
      [class.red]="isBomb()"
      [class.yellow]="!isBomb()"
    >
      @if (isBomb()) {
      <img src="assets/images/mines/mines-bomb.png" alt="bomb" class="bomb" />
      } @else {<img
        src="assets/images/core/tf2-logo-hex.png"
        alt="logo-tf2"
        class="logo"
      />}
    </div>

    <!--  -->
    @if (tileProfit()) {
    <div class="tile--value" [class.yellow]="!isBomb()" [class.red]="isBomb()">
      <app-balance-icon
        size="12px"
        [color]="isBomb() ? 'var(--red)' : 'var(--yellow)'"
        [balance]="minesService.currentGame().balancetype ?? 'skins'"
      />
      {{ tileProfit() | number : "1.2-2" }}
    </div>
    }
  </div>
</div>
